import { cn } from '@/context/global/utils/cn';

export type IconMusicDiskProps = {
  className?: string;
  size?: number;
};

export default function IconMusicDisk({ className = '', size = 50 }: IconMusicDiskProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(className)}
    >
      <path
        d="M45.6229 39.2011C45.6905 39.104 45.758 39.0068 45.8214 38.9055C45.8763 38.8252 45.9016 38.7281 45.9016 38.6352V11.3699C45.9016 11.2728 45.8721 11.1799 45.8214 11.0996C45.7538 11.0025 45.6905 10.9011 45.6229 10.804C45.3526 10.4155 44.7402 10.6097 44.7402 11.0827V38.9224C44.7402 39.3954 45.3526 39.5939 45.6229 39.2011Z"
        fill="url(#paint0_linear_1_27786)"
      />
      <path
        d="M39.2907 4.44325C39.2231 4.39679 39.1556 4.35034 39.088 4.30388C38.767 4.08428 38.332 4.32078 38.332 4.70932V45.2905C38.332 45.679 38.767 45.9113 39.088 45.6959C39.1556 45.6494 39.2231 45.603 39.2907 45.5565C39.4216 45.4678 39.4977 45.3158 39.4977 45.1553V4.84446C39.4977 4.68398 39.4216 4.53616 39.2907 4.44325Z"
        fill="url(#paint1_linear_1_27786)"
      />
      <path
        d="M47.9389 14.947C47.8967 14.8499 47.8545 14.7527 47.808 14.6556C47.5926 14.1784 46.8789 14.3304 46.8789 14.8541V35.1468C46.8789 35.6705 47.5926 35.8225 47.808 35.3453C47.8502 35.2481 47.8967 35.151 47.9389 35.0539C47.9643 34.9905 47.9812 34.9229 47.9812 34.8554V15.1413C47.9812 15.0737 47.9685 15.0061 47.9389 14.9428V14.947Z"
        fill="url(#paint2_linear_1_27786)"
      />
      <path
        d="M49.9225 22.5271C49.8634 21.9147 48.9512 21.957 48.9512 22.5736V27.4303C48.9512 28.0469 49.8592 28.0933 49.9225 27.4767"
        fill="url(#paint3_linear_1_27786)"
      />
      <path
        d="M25.0227 34.4537C25.293 34.4537 25.5084 34.6691 25.5084 34.9394V49.5138C25.5084 49.7883 25.7364 50.0122 26.011 49.9995C26.0785 49.9995 26.1461 49.9953 26.2179 49.991C26.4755 49.9784 26.6782 49.763 26.6782 49.5054V34.0356C26.6782 33.7653 26.8936 33.55 27.1639 33.55C27.4342 33.55 27.6496 33.7653 27.6496 34.0356V49.3407C27.6496 49.6321 27.903 49.8601 28.1901 49.8221C28.2577 49.8137 28.3295 49.8052 28.3971 49.7968C28.6378 49.763 28.8152 49.556 28.8152 49.3153V33.3895C28.8152 33.1192 29.0306 32.9038 29.3009 32.9038C29.5712 32.9038 29.7865 33.1192 29.7865 33.3895V48.9732C29.7865 49.2815 30.0695 49.5138 30.3693 49.4505C30.4369 49.4336 30.5087 49.4209 30.5763 49.404C30.7959 49.3533 30.9521 49.1548 30.9521 48.931V30.6697C30.9521 30.3994 31.1675 30.184 31.4378 30.184C31.7081 30.184 31.9235 30.3994 31.9235 30.6697V48.4073C31.9235 48.7367 32.2445 48.969 32.5612 48.8677C32.6246 48.8465 32.6921 48.8254 32.7555 48.8043C32.954 48.741 33.0891 48.5509 33.0891 48.3398V31.054C33.0891 30.7837 33.3045 30.5683 33.5748 30.5683C33.8451 30.5683 34.0605 30.7837 34.0605 31.054V47.6176C34.0605 47.9639 34.4152 48.2004 34.7319 48.0653C34.7995 48.0357 34.8671 48.0061 34.9347 47.9808C35.112 47.9048 35.2261 47.7274 35.2261 47.5331V2.46689C35.2261 2.27262 35.112 2.09947 34.9347 2.01922C34.8671 1.98966 34.7995 1.9601 34.7319 1.93476C34.411 1.79962 34.0605 2.03612 34.0605 2.38242V18.0042C34.0605 18.2745 33.8451 18.4899 33.5748 18.4899C33.3045 18.4899 33.0891 18.2745 33.0891 18.0042V1.66025C33.0891 1.44909 32.954 1.26326 32.7555 1.19569C32.6921 1.17458 32.6246 1.15346 32.5612 1.13234C32.2445 1.03098 31.9235 1.26326 31.9235 1.59268V18C31.9235 18.2703 31.7081 18.4856 31.4378 18.4856C31.1675 18.4856 30.9521 18.2703 30.9521 18V1.06899C30.9521 0.840939 30.7959 0.642446 30.5763 0.59599C30.5087 0.579097 30.4369 0.566429 30.3693 0.549536C30.0695 0.486187 29.7865 0.718464 29.7865 1.02676V18.0042C29.7865 18.2745 29.5712 18.4899 29.3009 18.4899C29.0306 18.4899 28.8152 18.2745 28.8152 18.0042V0.684679C28.8152 0.443954 28.6378 0.232792 28.3971 0.20323C28.3295 0.194783 28.2619 0.186336 28.1901 0.17789C27.903 0.139881 27.6496 0.372159 27.6496 0.659339V18.0042C27.6496 18.2745 27.4342 18.4899 27.1639 18.4899C26.8936 18.4899 26.6782 18.2745 26.6782 18.0042V0.494633C26.6782 0.237015 26.4755 0.0216291 26.2179 0.00895936C26.1503 0.00895936 26.0827 0.00473592 26.011 0.000512679C25.7364 -0.0121571 25.5084 0.211675 25.5084 0.486186V18.0042C25.5084 18.2745 25.293 18.4899 25.0227 18.4899C24.7524 18.4899 24.537 18.2745 24.537 18.0042V0.486186C24.537 0.211675 24.309 -0.0121571 24.0345 0.000512679C10.6721 0.519972 0 11.5131 0 24.9979C0 38.4827 10.6721 49.48 24.0345 49.9953C24.309 50.0079 24.537 49.7841 24.537 49.5096V34.9352C24.537 34.6649 24.7524 34.4495 25.0227 34.4495V34.4537Z"
        fill="url(#paint4_linear_1_27786)"
      />
      <path
        d="M43.6463 8.29499C43.583 8.22319 43.5154 8.1514 43.4521 8.0796C43.1522 7.75019 42.6074 7.96135 42.6074 8.40479V41.5953C42.6074 42.0387 43.1522 42.2499 43.4521 41.9205C43.5154 41.8487 43.583 41.7769 43.6463 41.7051C43.7266 41.6164 43.7688 41.4981 43.7688 41.3799V8.62018C43.7688 8.4977 43.7266 8.38368 43.6463 8.29499Z"
        fill="url(#paint5_linear_1_27786)"
      />
      <path
        d="M41.4697 6.14522C41.4063 6.09032 41.3387 6.03119 41.2754 5.97629C40.9586 5.706 40.4688 5.92561 40.4688 6.34371V43.6603C40.4688 44.0784 40.9586 44.298 41.2754 44.0277C41.3387 43.9728 41.4063 43.9137 41.4697 43.8588C41.5753 43.7659 41.6344 43.6307 41.6344 43.4914V6.51264C41.6344 6.37327 41.5753 6.23813 41.4697 6.14522Z"
        fill="url(#paint6_linear_1_27786)"
      />
      <path
        d="M36.9071 47.022C36.9747 46.984 37.0422 46.9502 37.1098 46.9122C37.2661 46.8277 37.359 46.663 37.359 46.4856V3.51413C37.359 3.33675 37.2661 3.17205 37.1098 3.08758C37.0422 3.04957 36.9747 3.01579 36.9071 2.97778C36.5861 2.80462 36.1934 3.04113 36.1934 3.40855V46.5912C36.1934 46.9586 36.5861 47.1951 36.9071 47.022Z"
        fill="url(#paint7_linear_1_27786)"
      />
      <path
        d="M25.0214 36.659C31.4589 36.659 36.6775 31.4403 36.6775 25.0028C36.6775 18.5653 31.4589 13.3467 25.0214 13.3467C18.5839 13.3467 13.3652 18.5653 13.3652 25.0028C13.3652 31.4403 18.5839 36.659 25.0214 36.659Z"
        fill="black"
      />
      <path
        d="M19.6211 25.0023V17.4258L26.184 21.214L32.7469 25.0023L26.184 28.7905L19.6211 32.5788V25.0023Z"
        fill="url(#paint8_linear_1_27786)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1_27786"
          x1="45.5595"
          y1="10.6013"
          x2="45.0823"
          y2="39.4038"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E84D8B" />
          <stop offset="0.13" stopColor="#E04D8C" />
          <stop offset="0.31" stopColor="#CC4F8F" />
          <stop offset="0.53" stopColor="#AA5293" />
          <stop offset="0.78" stopColor="#7C569A" />
          <stop offset="1" stopColor="#4F5BA1" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1_27786"
          x1="39.2569"
          y1="4.22787"
          x2="38.5728"
          y2="45.7761"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E84D8B" />
          <stop offset="0.13" stopColor="#E04D8C" />
          <stop offset="0.31" stopColor="#CC4F8F" />
          <stop offset="0.53" stopColor="#AA5293" />
          <stop offset="0.78" stopColor="#7C569A" />
          <stop offset="1" stopColor="#4F5BA1" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1_27786"
          x1="47.6053"
          y1="14.3726"
          x2="47.2548"
          y2="35.6324"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E84D8B" />
          <stop offset="0.13" stopColor="#E04D8C" />
          <stop offset="0.31" stopColor="#CC4F8F" />
          <stop offset="0.53" stopColor="#AA5293" />
          <stop offset="0.78" stopColor="#7C569A" />
          <stop offset="1" stopColor="#4F5BA1" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1_27786"
          x1="49.4833"
          y1="22.0879"
          x2="49.3904"
          y2="27.916"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E84D8B" />
          <stop offset="0.13" stopColor="#E04D8C" />
          <stop offset="0.31" stopColor="#CC4F8F" />
          <stop offset="0.53" stopColor="#AA5293" />
          <stop offset="0.78" stopColor="#7C569A" />
          <stop offset="1" stopColor="#4F5BA1" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_1_27786"
          x1="18.2106"
          y1="-0.126185"
          x2="17.3871"
          y2="49.8897"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E84D8B" />
          <stop offset="0.13" stopColor="#E04D8C" />
          <stop offset="0.31" stopColor="#CC4F8F" />
          <stop offset="0.53" stopColor="#AA5293" />
          <stop offset="0.78" stopColor="#7C569A" />
          <stop offset="1" stopColor="#4F5BA1" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_1_27786"
          x1="43.4647"
          y1="7.92757"
          x2="42.903"
          y2="42.0767"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E84D8B" />
          <stop offset="0.13" stopColor="#E04D8C" />
          <stop offset="0.31" stopColor="#CC4F8F" />
          <stop offset="0.53" stopColor="#AA5293" />
          <stop offset="0.78" stopColor="#7C569A" />
          <stop offset="1" stopColor="#4F5BA1" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_1_27786"
          x1="41.3683"
          y1="5.86648"
          x2="40.7348"
          y2="44.1417"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E84D8B" />
          <stop offset="0.13" stopColor="#E04D8C" />
          <stop offset="0.31" stopColor="#CC4F8F" />
          <stop offset="0.53" stopColor="#AA5293" />
          <stop offset="0.78" stopColor="#7C569A" />
          <stop offset="1" stopColor="#4F5BA1" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_1_27786"
          x1="37.1394"
          y1="2.9271"
          x2="36.413"
          y2="47.0769"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E84D8B" />
          <stop offset="0.13" stopColor="#E04D8C" />
          <stop offset="0.31" stopColor="#CC4F8F" />
          <stop offset="0.53" stopColor="#AA5293" />
          <stop offset="0.78" stopColor="#7C569A" />
          <stop offset="1" stopColor="#4F5BA1" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_1_27786"
          x1="19.4986"
          y1="24.9981"
          x2="32.7427"
          y2="25.2177"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E84D8B" />
          <stop offset="0.13" stopColor="#E04D8C" />
          <stop offset="0.31" stopColor="#CC4F8F" />
          <stop offset="0.53" stopColor="#AA5293" />
          <stop offset="0.78" stopColor="#7C569A" />
          <stop offset="1" stopColor="#4F5BA1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
